import PedidoService from "@/services/pedidos.service";
import {
  Pedido,
  PagePedidoInput,
  PayloadCreatePedido,
  PayloadCreateRenovacaoCRLV,
} from "@/models/pedido";
import { Pagination } from "@/api/pagination";
import GlobalStore from "@/store/modules/global";
import { router } from "@/router";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Documento, InputUpoloadDocumento } from "@/models/documento";
import DocumentoService from "@/services/documento.service";
import PagamentoService from "@/services/pagamento.service";
import { PageTipoDocumentoInput } from "@/models/tipo-documento";
import tipoDocumentoService from "@/services/tipo-documento.service";

import axios from "axios";
import { BACK_URL_SERVICE } from "@/commons/config";
import pedidosService from "@/services/pedidos.service";
const api = axios.create({ baseURL: BACK_URL_SERVICE });

export enum TipoDocumentoEnum {
  REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA = "REQUERIMENTO_ASSINADO_RECONHECIDO_FIRMA",
  COPIA_CRLV = "COPIA_CRLV",
  APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA = "APOLICE_SEGURO_ASSINADA_CARIMBADA_SEGURADORA",
  LAUDO_TECNICO = "LAUDO_TECNICO",
  ART = "ART",
  VISTORIA = "VISTORIA",
}

const unpermittedDocumentTypes = [
  "FOTO_DA_FRENTE_DO_VEICULO",
  "FOTO_DA_TRASEIRA_DO_VEICULO",
  "FOTO_LATERAL_REFERENTE_AO_LADO_DO_MOTORISTA",
  "FOTO_LATERAL_REFERENTE_AO_LADO_DE_ENTRADA_DOS_PASSAGEIROS",
  "FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_PRIMEIRAS_POLTRONAS",
  "FOTO_INTERIOR_DO_VEICULO_A_PARTIR_DAS_ULTIMAS_POLTRONAS",
  "FOTO_CHASSI"
]

const initialStatePaginateInput: any = {
  type_id: null,
  type_key: null,
  company_id: null,
  group: null,
  status: null,
  plate: null,
  payment_status: null,
  inspection_status: null,
  inspection_created_at: null,
  created_at: null
}

export const pedido = {
  namespaced: true,
  state: {
    table: {
      header: [
        {
          text: "Número",
          align: "start",
          sortable: true,
          value: "id",
        },
        {
          text: "Grupo",
          align: "start",
          sortable: true,
          value: "group",
        },
        {
          text: "Veículo",
          align: "start",
          sortable: true,
          value: "placa",
        },
        {
          text: "Tipo",
          align: "start",
          sortable: true,
          value: "typeSolicitation.name",
        },
        {
          text: "Status",
          align: "start",
          sortable: true,
          value: "status",
        },
        {
          text: "Data do pedido",
          align: "start",
          sortable: true,
          value: "createdAt",
        },
        {
          text: "Ações",
          align: "start",
          sortable: false,
          value: "actions",
        },
      ],
      content: [] as Array<Pedido>,
      paginate: {
        input: {
          type: null as null,
          status: null as null,
          group: null as null,
        },
        inputPage: {
          page: 1,
          size: 10,
          order: "id",
          descingOrder: true,
        },
      },
      isLoading: false,
      total: 0,
    },
    form: {
      isLoading: false,
      currentStep: 1,
      pedido: {
        typeSolicitation: null as string,
        veiculoTransportadoraId: null as string,
        placa: null as string,
      },
      documents: [] as Array<any>,
    },
    detail: {
      data: null as Pedido,
      isLoading: true,
    },
  },
  mutations: {
    setTableIsLoading(state: any, value: boolean): void {
      state.table.isLoading = value;
    },
    setTableContent(state: any, value: Pedido[]): void {
      state.table.content = value;
    },
    setTableTotal(state: any, value: number): void {
      state.table.total = value;
    },
    setTablePaginate(state: any, value: PagePedidoInput): void {
      state.table.paginate = value;
    },
    setFormIsLoading(state: any, value: boolean): void {
      state.form.isLoading = value;
    },
    setFormPedido(state: any, value: object): void {
      state.form.pedido = { ...value };
    },
    setFormCurrentStep(state: any, value: number): void {
      state.form.currentStep = value;
    },
    setFormDocumentos(state: any, value: Array<object>): void {
      state.form.documents = value;
    },
    setDetail(state: any, value: Pedido): void {
      state.detail.data = value;
    },
    setDetailIsLoading(state: any, value: boolean): void {
      state.detail.isLoading = value;
    },
    SET_DOCUMENT_FORM: (state: any, { typeDocumentKey, doc }: any) => {
      const docs = state.form.documents.map((d: any) => {
        return d.typeDocumentKey === typeDocumentKey ? { ...d, ...doc } : d;
      });
      state.form.documents = docs;
    },
    SET_DOCUMENTS_DETAIL: (state: any, docs: Array<any>) => {
      state.detail.data.documents = docs;
    },
    SET_PAYMENTS_GROUP: (state: any, payments: Array<any>) => {
      state.detail.data.payments = payments;
    },
    SET_PEDIDOS_GROUP: (state: any, pedidosGrupo: Array<any>) => {
      state.detail.data.pedidosGrupo = pedidosGrupo;
    },
  },
  actions: {
    SEARCH({ commit, dispatch, state }: any): void {
      commit("setTableIsLoading", true);
      PedidoService.list(state.table.paginate).subscribe(
        ({ items, totalItems }) => {
          commit("setTableContent", items);
          commit("setTableTotal", totalItems);
          commit("setTableIsLoading", false);
        },
        (error) => {
          commit("setTableIsLoading", false);
        }
      );
    },
    CHANGE_PAGE(
      { commit, dispatch, state }: any,
      value: PagePedidoInput
    ): void {
      commit("setTablePaginate", value);
    },
    CLEAR({ commit }: any): void {
      commit("setTableContent", []);
      commit("setTableTotal", 0);
      commit("setTableIsLoading", false);
      commit("setTablePaginate", {
        input: {
          ...initialStatePaginateInput
        },
        inputPage: {
          page: 1,
          per_page: 10,
          sort: "id:desc"
        },
      });
    },
    SHOW({ commit, dispatch, state }: any, value: number): void {
      commit("setDetailIsLoading", true);
      PedidoService.show(value).subscribe(
        (res) => {
          commit("setDetail", res);
          commit("setDetailIsLoading", false);
        },
        () => {
          commit("setDetailIsLoading", false);
          GlobalStore.setSnackBar({
            show: true,
            type: "error",
            message: "Pedido não encontrado",
          });
          router.push({ name: "dashboard-pedidos-list" });
        }
      );
    },
    CLEAR_DETAIL({ commit, dispatch, state }: any): void {
      commit("setDetail", null);
      commit("setDetailIsLoading", false);
    },
    DOWNLOAD_DOCUMENTO(
      { commit, dispatch, state }: any,
      value: Documento
    ): void {
      commit("setDetailIsLoading", true);
      DocumentoService.download(value).subscribe(
        (res) => {
          DocumentoService.doDownloadFile(res, value.name);
          commit("setDetailIsLoading", false);
        },
        (error) => {
          commit("setDetailIsLoading", false);
        }
      );
    },
    CURRENT_STEP({ commit, dispatch, state }: any, value: number): void {
      commit("setFormCurrentStep", value);
    },
    SET_FORM_PEDIDO(
      { commit, dispatch, state }: any,
      value: PayloadCreatePedido
    ): void {
      commit("setFormPedido", value);
    },
    CREATE_PAYMENT({ commit, dispatch, state }: any, data: any): void {
      commit("setDetailIsLoading", true);
      const body = {
        paymentData: {
          transactionAmount: Number(data.amount),
          token: data.token,
          description: state.detail.data.typeSolicitation.name,
          installments: data.installments,
          paymentMethodId: data.paymentMethodId,
          issuerId: data.issuerId,
          payer: {
            firstName: state.detail.data.company.name,
            lastName: state.detail.data.company.name,
            email: data.cardholderEmail,
            identification: {
              type: "CNPJ", // data.identificationType
              number: data.identificationNumber,
            },
          },
        },
        solicitationData: {
          id: state.detail.data.id,
        },
      };
      PagamentoService.create(body).subscribe(
        (res) => {
          commit("setDetailIsLoading", false);
          router.currentRoute.name === "renovacao-crlv"
            ? router.push({
              name: "pedidos-detail",
              params: { id: state.detail.data.id },
            })
            : dispatch("SHOW", state.detail.data.id);
        },
        (err) => {
          commit("setDetailIsLoading", false);
        }
      );
    },
  },
};

